import $ from 'jquery';
import * as Utils from 'lib/utils';
import config from 'lib/config';

const W = window;
const $W = $(W);

$(() => {
  const $B = $('body');
  const $appMenuToggle = $('.app-menu-toggle');
  const $appMenu = $('.app-menu');
  const $pageMenu = $B.find('.page-menu');
  const $pageSubmenu = $B.find('.page-submenu');

  function updateAppMenu(state) {
    if (state === 'open') $B.hideUI();
    $B.removeClass('app-menu-open app-menu-closed').addClass(`app-menu-${state}`);
    if (W.innerWidth >= 768) $.userStorage.set('menu', state);
  }

  function updatePageMenu(state) {
    if (state === 'open') $B.hideUI();
    $B.removeClass('page-menu-open page-menu-closed').addClass(`page-menu-${state}`);
  }

  $appMenuToggle.on('click', evt => {
    updateAppMenu($B.is('.app-menu-open') ? 'closed' : 'open');
    return false;
  });

  $appMenu.on('show.bs.tooltip', '.app-menu-item', evt => {
    return !$B.is('.app-menu-open');
  });

  $W.on(
    'resize',
    $.throttle(200, () => {
      if (W.innerWidth < 992 && $B.is('.app-menu-open')) updateAppMenu('closed');
    }),
  );

  $B.on('click', '.pane-app-right', () => {
    if (W.innerWidth < 576 && $B.is('.app-menu-open')) updateAppMenu('closed');
  });

  $B.on('click', '.pane-page-right', () => {
    if (W.innerWidth < 576 && $B.is('.page-menu-open')) updatePageMenu('closed');
  });

  $.onAuth(async auth => {
    const $btn = $('.admin-site-menu');

    if ($btn.length) {
      $btn
        .addQuery(
          `
            query listWebsites {
              data: listWebsites {
                id
                name
                domain
                is_licensee
              }
            }
          `,
        )

        .on('show.bs.popover', async evt => {
          const loaded = $btn.data('loaded');
          const $menu = $('#admin-sites-popover .popover-scroll');

          if ($menu.children().length) return;
          if (loaded !== true) {
            evt.preventDefault();

            const { data } = await $btn.runQuery('listWebsites');
            const groups = Utils.groupBy(data, 'is_licensee');

            for (const [is_licensee, websites] of Object.entries(groups)) {
              $('<div class="popover-menu-header"></div>')
                .text(is_licensee === 'true' ? 'Licensee' : 'Miedema')
                .appendTo($menu);

              for (const website of websites) {
                $('<a class="popover-menu-item"></a>').attr('href', `https://${website.domain}${location.pathname}`).text(website.name).appendTo($menu);
              }
            }

            $btn.data('loaded', true).popover('show');
          }
        })

        .on('shown.bs.popover', () => {
          $btn.data('loaded', false);
          $btn.find('.fa').removeClass('fa-caret-down').addClass('fa-caret-up');
        })

        .on('hidden.bs.popover', () => {
          $btn.find('.fa').removeClass('fa-caret-up').addClass('fa-caret-down');
        });
    }
  });
});
